import useMedia from "use-media";
import { Button } from "../atoms/button";
import "../../resources/css/search/search.css";

export const CompleteDialog = (props) => {
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const { state, onClickOpenComplete } = props;
    return (
        <div style={state ? style.popupIsShow : style.popup}>
            <div style={useMediaFlag ? style.popupInnerMedia : style.popupInner}>
                <div>
                    <div style={style.title}>登録完了しました。</div>
                    <div style={style.btnArea}>
                        <Button buttonText="閉じる" className="dialogCloseBtn" onClick={onClickOpenComplete} />
                    </div>
                </div>
            </div>
            <div style={style.blackBackground} id="js-black-bg"></div>
        </div>
    );
};

const style = {
    popup: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "0",
        visibility: "hidden",
        transition: ".6s",
    },
    popupIsShow: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "1",
        visibility: "visible",
        transition: ".6s",
    },
    popupInner: {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "45%",
        backgroundColor: "#fff",
        zIndex: "2",
        height:"30%",
        display:"flex",
        justifyContent: "center",
        alignItems: "center"
    },
    popupInnerMedia:{
        position: "absolute",
        left: "0%",
        bottom: "0%",
        // transform: "translate(-50%, -50%)",
        width: "100%",
        backgroundColor: "#fff",
        zIndex: "2",
        height:"35%",
        display:"flex",
        justifyContent: "center",
        alignItems: "center"
    },
    blackBackground: {
        position: "absolute",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, .8)",
        zIndex: "1",
    },
    title:{
        fontSize:18,
        textAlign:'center',
        letterSpacing:'1'
    },
    btnArea:{
        display:'flex',
        justifyContent:'center',
        marginTop:20,
        width: 200
    }
}